import {TbForbid} from "react-icons/tb";
import {HiShieldCheck} from "react-icons/hi";
import Button from "../Button";
import {ImHourGlass} from "react-icons/im";
const defaultTitle={
    'fail':'ناموفق',
    'pending':'در حال بررسی',
    'success':'موفق'
}
const finalCard=({finalData,handleRedirect})=>{
    const {status,message}=finalData;
    const handleClick=()=>{
        if(typeof handleRedirect==='function'){
            handleRedirect({
                status:status,
                price:0,
            })
        }
    }
    return <div className="min-h-screen flex justify-center items-center">
        <div
            className="w-11/12 rounded-lg bg-white mt-16 p-5 mx-auto flex flex-col justify-center items-center gap-2  md:max-w-md">
            {status === 'fail' && <TbForbid className="text-5xl mb-2 text-red-500"/>}
            {status === 'pending' && <ImHourGlass className="text-5xl mb-2 text-yellow-500"/>}
            {status === 'success' && <HiShieldCheck className="text-5xl mb-2 text-green-500"/>}
            {status && <h1 className="text-lg text-center font-semibold">{defaultTitle[status]}</h1>}
            <p className="text-sm text-center">{message}</p>
            <Button rounded="rounded-lg" onClick={handleClick}
                    theme={status === 'success' ? 'green' : status === 'pending' ? 'warning' : 'red'}
                    className="text-sm mt-4 w-full">بازگشت</Button>

        </div>
    </div>
}
export default finalCard;